export class SessionStorageUtils {
  static save(key: string, value: string): boolean {
    window.sessionStorage.setItem(key, value);
    return true;
  }

  static get<T = string>(key: string): T {
    return window.sessionStorage.getItem(key) as unknown as T;
  }

  static clear() {
    window.sessionStorage.clear();
  }
}
